export interface BillingViewModel {
  headline: string;
  searchBoxPlaceholder: string;
  listHeadline: string;
  approvedInvoicesListHeadline: string;
  sentForPaymentListHeadline: string;
  activeInvoiceHeadline: string;
  approveInvoiceBtn: string;
  approveInvoiceSuccessMsg: string;
  approveInvoiceErrorMsg: string;
  exportInvoiceAsPdfBtn: string;
  exportInvoiceAsPdfErrorMsg: string;
  exportInvoiceAsCsvBtn: string;
  exportInvoiceAsCsvErrorMsg: string;
  downloadApprovedInvoiceBtn: string;
  downloadApprovedInvoiceErrorMsg: string;
}

export interface InvoiceDocumentListItem {
  referenceNumber: string;
  invoiceNumber: string;
  periodStartDate?: Date;
  periodEndDate?: Date;
  totalAmount?: number;
  amountVat?: number;
  invoiceItems: InvoiceListItem[];
  status?: number;
  statusLabel: string;
  hasPDF: boolean;
  createdAfterStartDateSelfInvoicing?: boolean;
}

export interface InvoiceListItem {
  tslNumber: string;
  county: string;
  participantId: string;
  productName: string;
  amount?: number;
  partialInvoice: string;
  partialInvoiceLabel: string;
}

const partialInvoice: Record<string, string> = {
  '0': '',
  '1': 'Delfakturerad',
  '2': 'Fullt fakturerad',
};

const invoiceStatusMap: Record<number, string> = {
  1: 'Utkast',
  2: 'Publicerad',
  4: 'Skickad för utbetalning',
  5: 'Godkänd av leverantör',
};

export const getInvoiceStatusLabel = (statusId: number): string => {
  return invoiceStatusMap[statusId] || 'Okänd status'; // Default fallback
};

export const getPartialInvoiceLabel = (partialInvoiceId: string): string => {
  return partialInvoice[partialInvoiceId] || 'Okänd faktureringstyp'; // Default fallback
};
